import { render, staticRenderFns } from "./playerIndex.vue?vue&type=template&id=52912d2c&scoped=true"
import script from "./playerIndex.vue?vue&type=script&lang=js"
export * from "./playerIndex.vue?vue&type=script&lang=js"
import style0 from "./playerIndex.vue?vue&type=style&index=0&id=52912d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52912d2c",
  null
  
)

export default component.exports